import apiRemovalRequestsInfos from '@/api/removal-requests'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  removalRequestsInfo: null,
}

export const mutationTypes = {
  getRemovalRequestsInfoStart:
    '[removalRequestsInfo] Get removalRequestsInfo start',
  getRemovalRequestsInfoSuccess:
    '[removalRequestsInfo] Get removalRequestsInfo success',
  getRemovalRequestsInfoFailure:
    '[removalRequestsInfo] Get removalRequestsInfo failure',

  updateRemovalRequestsInfoStart:
    '[removalRequestsInfo] Update removalRequestsInfo start',
  updateRemovalRequestsInfoSuccess:
    '[removalRequestsInfo] Update removalRequestsInfo success',
  updateRemovalRequestsInfoFailure:
    '[removalRequestsInfo] Update removalRequestsInfo failure',

  updateEnrollmentStatusStart:
    '[removalRequestsInfo] Update status removalRequestsInfo start',
  updateEnrollmentStatusSuccess:
    '[removalRequestsInfo] Update status removalRequestsInfo success',
  updateEnrollmentStatusFailure:
    '[removalRequestsInfo] Update status removalRequestsInfo failure',
}

export const actionTypes = {
  getRemovalRequestsInfo: '[removalRequestsInfo] Get removalRequestsInfo',
  updateRemovalRequestsInfo: '[removalRequestsInfo] Update removalRequestsInfo',
  updateRemovalRequestsStatus:
    '[removalRequestsInfo] Update status removalRequestsInfo',
}

const mutations = {
  [mutationTypes.getRemovalRequestsInfoStart](state) {
    state.isLoading = true
    state.removalRequestsInfo = null
  },

  [mutationTypes.getRemovalRequestsInfoSuccess](state, payload) {
    state.removalRequestsInfo = payload
    state.isLoading = false
  },

  [mutationTypes.getRemovalRequestsInfoFailure](state) {
    state.isLoading = false
  },

  [mutationTypes.updateRemovalRequestsInfoStart](state) {
    state.isLoading = true
    state.removalRequestsInfo = null
  },

  [mutationTypes.updateRemovalRequestsInfoSuccess](state, payload) {
    state.removalRequestsInfo = payload
    state.isLoading = false
  },

  [mutationTypes.updateRemovalRequestsInfoFailure](state) {
    state.isLoading = false
  },

  [mutationTypes.updateEnrollmentStatusStart](state) {
    state.isLoading = true
  },

  [mutationTypes.updateEnrollmentStatusSuccess](state) {
    state.isLoading = false
  },

  [mutationTypes.updateEnrollmentStatusFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.getRemovalRequestsInfo](context, {id}) {
    context.commit(mutationTypes.getRemovalRequestsInfoStart)
    return new Promise((resolve) => {
      apiRemovalRequestsInfos
        .getRemovalRequestsInfo(id)
        .then((response) => {
          context.commit(
            mutationTypes.getRemovalRequestsInfoSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getRemovalRequestsInfoFailure)
        })
    })
  },

  [actionTypes.updateRemovalRequestsInfo](context, removalRequestsInfo) {
    context.commit(mutationTypes.updateRemovalRequestsInfoStart)
    return new Promise((resolve) => {
      apiRemovalRequestsInfos
        .changeEnrollment(removalRequestsInfo)
        .then((response) => {
          context.commit(
            mutationTypes.updateRemovalRequestsInfoSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.updateRemovalRequestsInfoFailure)
        })
    })
  },

  [actionTypes.updateRemovalRequestsStatus](context, {feedbackId, data}) {
    context.commit(mutationTypes.updateEnrollmentStatusStart)
    return new Promise((resolve) => {
      apiRemovalRequestsInfos
        .changeRemovalRequestsStatus(feedbackId, data)
        .then((response) => {
          context.commit(
            mutationTypes.updateEnrollmentStatusSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.updateEnrollmentStatusFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
